import $ from 'jquery';

export default () => {
    // $('.irMosaicoEsagoni__grid').masonry({
    //     itemSelector: '.irMosaicoEsagoni__box-item',
    //     percentage: true
    // });
};



// WEBPACK FOOTER //
// ../views/componente-mosaico-esagoni/mosaico-esagoni.js